import { useFlags } from "launchdarkly-react-client-sdk";
// import camelCase from "lodash.camelcase";
import { FeatureFlagKey } from "@/types/featureFlags";

export const useFeatureFlag = (flagKey: FeatureFlagKey): boolean => {
  const flags = useFlags();
  // useFlags() camelCases all keys (e.g. "APP_ADMIN_TOOL_DASHBOARD" → "appAdminToolDashboard")
  return Boolean(flags[flagKey]);
};
